/**
 * Monochrome "thinking" shimmer.
 *
 * A muted base text with a brighter highlight band sweeping left→right on a loop
 * — the best-in-class AI "thinking" treatment (ChatGPT / Claude). The text
 * itself is the liveness cue, so no spinner is needed alongside it.
 *
 * The gradient, text-clip, and animation all live in the self-contained
 * `.animate-shimmer` class in index.css (built from `--color-text-*` tokens), so
 * this is just that class name — there is no dependency on Tailwind gradient
 * utilities resolving. Under `prefers-reduced-motion: reduce` it degrades to a
 * solid, readable label.
 *
 * Kept in a component-free module (paired with ShimmerText.tsx) so files that
 * only need the class string don't import a component, satisfying
 * react-refresh's only-export-components rule.
 */
export const SHIMMER_TEXT_CLASS = 'animate-shimmer';
